'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GenericRibbonItem from './GenericRibbonItem';
import GenericRibbonSubjectLabel from './GenericRibbonSubjectLabel';
import { POSITION, SELECTION } from '../enums';

var GenericRibbonSubject = function (_Component) {
  _inherits(GenericRibbonSubject, _Component);

  function GenericRibbonSubject(props) {
    _classCallCheck(this, GenericRibbonSubject);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      categories: props.categories,
      subject: props.subject,

      selected: props.selected,
      selectionMode: props.selectionMode,

      showItemAll: props.showItemAll,

      hideLabel: props.hideLabel,
      newTab: props.newTab,
      useTaxonIcon: props.useTaxonIcon,
      subjectLabelPosition: props.subjectLabelPosition,
      subjectBaseURL: props.subjectBaseURL,

      classLabels: props.classLabels,
      annotationLabels: props.annotationLabels,
      colorBy: props.colorBy,
      binaryColor: props.binaryColor,
      minColor: props.minColor,
      maxColor: props.maxColor,
      maxHeatLevel: props.maxHeatLevel,

      itemEnter: props.itemEnter,
      itemLeave: props.itemLeave,
      itemOver: props.itemOver,
      itemClick: props.itemClick
    };
    return _this;
  }

  GenericRibbonSubject.prototype.componentDidMount = function componentDidMount() {};

  GenericRibbonSubject.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return true;
  };

  GenericRibbonSubject.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {};

  GenericRibbonSubject.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      categories: nextProps.categories,
      subject: nextProps.subject,

      selected: nextProps.selected,
      selectionMode: nextProps.selectionMode,

      showItemAll: nextProps.showItemAll,

      hideLabel: nextProps.hideLabel,
      newTab: nextProps.newTab,
      useTaxonIcon: nextProps.useTaxonIcon,
      subjectLabelPosition: nextProps.subjectLabelPosition,
      subjectBaseURL: nextProps.subjectBaseURL,

      classLabels: nextProps.classLabels,
      annotationLabels: nextProps.annotationLabels,
      colorBy: nextProps.colorBy,
      binaryColor: nextProps.binaryColor,
      minColor: nextProps.minColor,
      maxColor: nextProps.maxColor,
      maxHeatLevel: nextProps.maxHeatLevel,

      itemEnter: nextProps.itemEnter,
      itemLeave: nextProps.itemLeave,
      itemOver: nextProps.itemOver,
      itemClick: nextProps.itemClick
    });
  };

  GenericRibbonSubject.prototype.render = function render() {
    var _this2 = this;

    // console.log("GRS: ", this.state);
    // console.log('subject: ', this.state.subject);
    // console.log("GRS(" + this.state.subject.id + ")::render (state): ", this.state);
    return React.createElement(
      'div',
      { className: 'ontology-ribbon__strip' },
      this.state.subjectLabelPosition == POSITION.LEFT && !this.state.hideLabel && (this.props.subjectLabel ? React.createElement(
        'div',
        { className: 'ontology-ribbon__item__subject' },
        this.props.subjectLabel(this.state.subject)
      ) : React.createElement(GenericRibbonSubjectLabel, { subjectId: this.state.subject.id,
        subjectLabel: this.state.subject.label,
        subjectTaxon: this.state.subject.taxon_label,
        subjectBaseURL: this.state.subjectBaseURL,
        useTaxonIcon: this.state.useTaxonIcon,
        newTab: this.state.newTab
      })),
      this.state.showItemAll ? React.createElement(
        'div',
        { className: 'ontology-ribbon__item__category' },
        React.createElement(GenericRibbonItem, { subject: this.state.subject,
          group: {
            "id": "all",
            "label": "All annotations",
            "description": "Show all annotations",
            "type": "GlobalAll"
          },
          data: {
            "ALL": {
              "nb_classes": this.state.subject.nb_classes,
              "nb_annotations": this.state.subject.nb_annotations
            }
          },

          isSelected: this.state.selected && this.state.selected.subject && this.state.selected.group ? this.state.selectionMode == SELECTION.CELL && this.state.selected.subject.id == this.state.subject.id && this.state.selected.group.id == "all" || this.state.selectionMode == SELECTION.COLUMN && this.state.selected.group.id == "all" : false,

          classLabels: this.state.classLabels,
          annotationLabels: this.state.annotationLabels,
          colorBy: this.state.colorBy,
          binaryColor: this.state.binaryColor,
          minColor: this.state.minColor,
          maxColor: this.state.maxColor,
          maxHeatLevel: this.state.maxHeatLevel,

          itemEnter: this.state.itemEnter,
          itemLeave: this.state.itemLeave,
          itemOver: this.state.itemOver,
          itemClick: this.state.itemClick

        })
      ) : '',
      this.state.categories.map(function (category) {
        return React.createElement(
          'div',
          { className: 'ontology-ribbon__item__category',
            key: _this2.state.subject + "_" + category.id },
          category.groups.map(function (group, index) {
            return React.createElement(GenericRibbonItem, { subject: _this2.state.subject,
              group: group,
              data: _this2.state.subject.groups[group.id + (group.type == "Other" ? "-other" : "")],

              isSelected: _this2.state.selected && _this2.state.selected.subject && _this2.state.selected.group ? _this2.state.selectionMode == SELECTION.CELL && _this2.state.selected.subject.id == _this2.state.subject.id && _this2.state.selected.group.id == group.id && _this2.state.selected.group.type == group.type || _this2.state.selectionMode == SELECTION.COLUMN && _this2.state.selected.group.id == group.id && _this2.state.selected.group.type == group.type : false,

              classLabels: _this2.state.classLabels,
              annotationLabels: _this2.state.annotationLabels,
              colorBy: _this2.state.colorBy,
              binaryColor: _this2.state.binaryColor,
              minColor: _this2.state.minColor,
              maxColor: _this2.state.maxColor,
              maxHeatLevel: _this2.state.maxHeatLevel,

              itemEnter: _this2.state.itemEnter,
              itemLeave: _this2.state.itemLeave,
              itemOver: _this2.state.itemOver,
              itemClick: _this2.state.itemClick,

              key: _this2.state.subject + "_" + category.id + "_" + group.id + "_" + index });
          })
        );
      }),
      this.state.subjectLabelPosition == POSITION.RIGHT && !this.state.hideLabel && (this.props.subjectLabel ? React.createElement(
        'div',
        { className: 'ontology-ribbon__item__subject' },
        this.props.subjectLabel(this.state.subject)
      ) : React.createElement(GenericRibbonSubjectLabel, { subjectId: this.state.subject.id,
        subjectLabel: this.state.subject.label,
        subjectTaxon: this.state.subject.taxon_label,
        subjectBaseURL: this.state.subjectBaseURL,
        useTaxonIcon: this.state.useTaxonIcon,
        newTab: this.state.newTab
      }))
    );
  };

  return GenericRibbonSubject;
}(Component);

GenericRibbonSubject.propTypes = process.env.NODE_ENV !== "production" ? {
  categories: PropTypes.array.isRequired,
  subject: PropTypes.object.isRequired,

  showItemAll: PropTypes.bool,
  selected: PropTypes.object,
  selectionMode: PropTypes.number,

  hideLabel: PropTypes.bool,
  newTab: PropTypes.bool,
  useTaxonIcon: PropTypes.bool,
  subjectLabel: PropTypes.func,
  subjectLabelPosition: PropTypes.number,
  subjectBaseURL: PropTypes.string,

  classLabels: PropTypes.array,
  annotationLabels: PropTypes.array,
  colorBy: PropTypes.number,
  binaryColor: PropTypes.bool,
  minColor: PropTypes.array,
  maxColor: PropTypes.array,
  maxHeatLevel: PropTypes.number,

  itemEnter: PropTypes.func,
  itemLeave: PropTypes.func,
  itemOver: PropTypes.func,
  itemClick: PropTypes.func
} : {};

GenericRibbonSubject.defaultProps = {};

export default GenericRibbonSubject;